exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".dot{width:10px;height:10px;border-radius:50%;background-color:#000}.dice-edge{width:4rem;height:4rem;border-radius:5%;background-color:gray;margin-bottom:2px}.dice-edge,.dice-edge:active,.dice-edge:focus,.dice-edge:hover{outline:none!important;border:0!important}.slim{padding:.5rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/components/home/dice/dice.scss
// module id = 461
// module chunks = 0